/**
 * files-view.js
 */

import React from 'react';
import { Typography, Link, Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import IconSection from 'components/icon-section';
import FileTypeIcon from 'components/file-type-icon';


const useStyles = makeStyles(theme => ({
  container: {
    flex: '1 0 20%',
    minWidth: 70,
    maxWidth: '33%',
    maxHeight: 160,
    overflow: 'hidden',
    padding: theme.spacing(0.25),
    margin: theme.spacing(0.5),
    backgroundColor: theme.palette.sys.surfaceContainer,
    borderRadius: 4,
    lineHeight: 0,
    textTransform: 'none',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '48%',
      flex: '1 0 33%',
    },
    '&.MuiButton-containedPrimary:hover': {
      backgroundColor: theme.palette.sys.surfaceContainerHigh,
    },
  },
  previewContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  previewIcon: {
    minHeight: '120px',
    width: '30%',
  },
  previewPic: {
    width: '100%',
    height: '120px',
    objectFit: 'cover',
  },
  previewText: {
    height: theme.spacing(3),
    width: '90%',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      width: '100%',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      fontWeight: theme.typography.fontWeightMedium,
    }
  }
}));


export default function FilesView(props) {
  const { files } = props;
  const classes = useStyles();


  const getPreview = (file) => {
    const ext = file.url.split('.').pop().toLowerCase();
    let filename = file.filename ?? file.url;
    filename = filename.substring(filename.lastIndexOf('/') + 1);
    const filenameWithoutExt = filename.substring(0, filename.lastIndexOf('.')) || filename;
    const canRenderImage = ["jpg", "jpeg", "png", "gif", "bmp"].includes(ext);
    const previewPic = canRenderImage ?
      <img src={file.url} alt={filename} className={classes.previewPic} />
      : <FileTypeIcon className={classes.previewIcon} filename={file.url} />;
    return (
      <div className={classes.previewContainer}>
        {previewPic}
        <div className={classes.previewText}>
          <Typography variant='caption'>
            {filenameWithoutExt}
          </Typography>
        </div>
      </div>
    )
  };


  return <>
    {/* files */}
    {files && files.length > 0 &&
      <IconSection iconName='user-guide'>
        <Typography variant='subtitle2' style={{ marginBottom: 8 }}>
          Files
        </Typography>
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          {files.map(file =>
            <Button
              key={file.id}
              variant="contained"
              color="primary"
              disableElevation
              className={classes.container}
            >
              <Link
                href={file.url}
                target="_blank"
                style={{ width: '100%', textDecoration: 'none' }}
                underline="hover">
                {getPreview(file)}
              </Link>
            </Button>
          )}
        </div>
      </IconSection>}
  </>;
}